import * as e from "react";
import { forwardRef as L } from "react";
const a = L(
  function(t, C) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: C,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("circle", { cx: 12.0357, cy: 6.03571, fill: "#FFCA00", r: 2.03571 }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M11 14.5L10.0414 17.8549C10.0169 17.9408 9.93844 18 9.84914 18H6.5M11 14.5L13.5954 15.7977C13.858 15.929 14.071 16.142 14.2023 16.4046L15.5 19M11 14.5L12.2529 10.7414C12.3683 10.3952 12.086 10.046 11.7233 10.0863L8.54591 10.4393C7.45629 10.5604 7.32748 12.0936 8.38163 12.3948L10.5 13",
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.2863 11.3362C19.8484 11.3362 20.3041 10.8804 20.3041 10.3183C20.3041 9.75615 19.8484 9.30044 19.2863 9.30044L19.2863 11.3362ZM16.8046 10.3183L16.8046 9.30044L16.8026 9.30044L16.8046 10.3183ZM15.0003 9.30392L13.9824 9.30589L13.9863 11.3416L15.0042 11.3396L15.0003 9.30392ZM16.8046 10.3183L16.8046 11.3362L19.2863 11.3362L19.2863 10.3183L19.2863 9.30044L16.8046 9.30044L16.8046 10.3183ZM16.8046 10.3183L16.8026 9.30044L15.0003 9.30392L15.0022 10.3218L15.0042 11.3396L16.8066 11.3362L16.8046 10.3183Z",
          fill: "#FFCA00"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M9.17083 11.4094C9.26982 11.1234 10.4471 10.506 11.5085 10.8734C12.57 11.2408 13.1533 12.3395 13.0147 12.7399C12.8761 13.1403 11.7384 13.6433 10.677 13.2759C10.0463 13.0575 9.59835 12.5406 9.35946 12.0971L9.326 12.0327C9.18748 11.7566 9.13353 11.5172 9.17083 11.4094Z",
          fill: "#815337",
          stroke: "#815337",
          strokeWidth: 0.65427
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.1161 13.0155C12.1096 12.7602 12.1262 12.573 12.1694 12.4478C12.2127 12.3226 12.3156 12.1644 12.4789 11.9675C12.5253 11.9114 12.6086 11.9035 12.6647 11.9499C12.7207 11.9964 12.7286 12.0797 12.6822 12.1358L12.6273 12.2037L12.5785 12.2665C12.4946 12.3786 12.4407 12.4685 12.4182 12.5332C12.3958 12.598 12.3827 12.702 12.3793 12.842L12.3779 12.9219C12.378 12.9497 12.3792 12.9787 12.38 13.0089C12.3819 13.0816 12.3241 13.1422 12.2513 13.1441C12.1786 13.146 12.118 13.0882 12.1161 13.0155ZM9.52108 12.1991C9.46512 12.1526 9.45714 12.0692 9.50356 12.0132C9.64819 11.8387 9.737 11.704 9.76756 11.6157C9.7981 11.5274 9.81157 11.3667 9.80578 11.1401C9.80395 11.0674 9.86168 11.0068 9.93443 11.0049C10.0072 11.003 10.0678 11.0608 10.0697 11.1335C10.0762 11.3893 10.0593 11.5773 10.016 11.7025C9.97253 11.8275 9.86981 11.9849 9.70691 12.1815C9.66045 12.2376 9.57714 12.2455 9.52108 12.1991Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.2475 11.7822C10.2696 11.7183 10.3359 11.6823 10.4004 11.6965L10.4152 11.7007L11.8566 12.1997C11.9254 12.2235 11.9619 12.2985 11.9381 12.3673C11.916 12.4312 11.8497 12.4672 11.7852 12.453L11.7704 12.4488L10.3289 11.9499C10.2601 11.926 10.2237 11.851 10.2475 11.7822Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.5709 11.6249C10.5947 11.5561 10.6698 11.5197 10.7386 11.5435C10.8025 11.5656 10.8385 11.6319 10.8242 11.6963L10.82 11.7112L10.6537 12.1916C10.6299 12.2604 10.5548 12.2969 10.486 12.2731C10.4221 12.251 10.3861 12.1847 10.4004 12.1202L10.4046 12.1054L10.5709 11.6249Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M11.0514 11.7912C11.0752 11.7224 11.1503 11.6859 11.2191 11.7097C11.283 11.7318 11.319 11.7982 11.3047 11.8626L11.3006 11.8774L11.1342 12.3579C11.1104 12.4267 11.0353 12.4632 10.9665 12.4394C10.9027 12.4172 10.8667 12.3509 10.8809 12.2865L10.8851 12.2717L11.0514 11.7912Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M11.3844 11.6337C11.4082 11.5649 11.4833 11.5285 11.5521 11.5523C11.616 11.5744 11.652 11.6407 11.6377 11.7051L11.6335 11.72L11.4672 12.2004C11.4434 12.2692 11.3683 12.3057 11.2995 12.2819C11.2356 12.2598 11.1996 12.1935 11.2139 12.129L11.2181 12.1142L11.3844 11.6337Z",
          fill: "#815337"
        }
      )
    );
  }
);
export {
  a as BetBuilderBadgeAmericanRushingActive
};
